import React from "react";

export default function TimeFormatToggle({ value, onChange }) {
  return (
    <div className="time-format-control" role="group" aria-label="Time format">
      <span className="time-format-control__label" aria-hidden="true">Time format</span>
      <div className="time-format-control__buttons">
        <button
          type="button"
          className={`time-format-control__btn${value === "12h" ? " time-format-control__btn--active" : ""}`}
          aria-pressed={value === "12h"}
          onClick={() => onChange("12h")}
        >
          AM/PM
        </button>
        <button
          type="button"
          className={`time-format-control__btn${value === "24h" ? " time-format-control__btn--active" : ""}`}
          aria-pressed={value === "24h"}
          onClick={() => onChange("24h")}
        >
          Military
        </button>
      </div>
    </div>
  );
}
